import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-svh w-full" }
const _hoisted_2 = { class: "flex flex-1 flex-col md:ml-[88px] overflow-x-hidden" }
const _hoisted_3 = { class: "flex flex-1 flex-col gap-4 p-4" }

import { onMounted, onUnmounted } from 'vue'
import { useGlobalSubscriptions } from '@/composables/useGlobalSubscriptions'
import AppSidebar from '@/components/AppSidebar.vue'
import Navbar from './components/Navbar.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {

const { onMount, onUnmount } = useGlobalSubscriptions()

onMounted(() => {
  onMount()
})

onUnmounted(() => {
  onUnmount()
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppSidebar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Navbar),
      _createElementVNode("main", _hoisted_3, [
        _createVNode(_component_RouterView)
      ])
    ])
  ]))
}
}

})